import React from 'react';
import {
  Container, Image
} from 'react-bootstrap';
import ReactPlayer from 'react-player';
import { Tron } from './Tron';

export const APIBackendWindows = () => {
  
  let homeTron = {
    title: 'Workspace ONE Excel Add-In (Beta) API',
    description: 'This is the Installation page for the Caching API for the Workspace ONE Excel Add-In',
    body: <><p>Because the Excel add-in is much more responsive with a caching layer, I've chosen to show how to deploy
      using an in-memory cache. </p>
      <p>I've decided to show the back end installation separately from running the application because you can choose
        to run the api on a separate Computer/VM <b>However</b>, you can definitely run the Caching API locally on a
        bigger
        computer</p>
      <p>Below you will find the step by step instructions as well as a video counterpart.</p>
    </>
  };
  
  
  return (
    
    <Container>
      <Tron tronProps={homeTron}/>
      <Container>
        <h3>Video overview of the Caching API server installation</h3>
        <ReactPlayer url="https://www.youtube.com/watch?v=eDUXEjtgqo8" config={{
          youtube: {
            playerVars: { showinfo: 1, controls: true }
          }
        }}>
        </ReactPlayer>
        
        
        <h4 id="overview-of-apps">Overview of apps used</h4>
        <p>On Windows, Memurai has built an excellent product, I’ll be installing using Memurai.</p>
        <p>Nodejs is used to run the API backend.</p>
        <p>Optionally, you can choose to put Nginx in front of Nodejs if your
          security team requires it, but I won’t be covering that here. Reach out if you need help.</p>
        <h4 id="requirements">Requirements</h4>
        
        <p>The requirements are pretty light. It's an in-memory cache, so high disk i/o will not be required. The size
          of your environment will determine the RAM size required.</p>
        <p>Here are some general guidelines:</p>
        <ul>
          <li>If your environment has 10000 devices
            <ul>
              <li>Memory requirements should not exceed 500 megabytes. So 4GB for the computer/VM.</li>
              <li>CPU would be 2 Cores/4 Threads.</li>
              <li>Disk space minimal - Same as Windows</li>
            </ul></li>
          <li>If your environment contains 100,000 devices:
            <ul>
              <li>Plan for 4-6 gigabytes of RAM for the cache, which probably means 8-10 GB for the computer/VM.</li>
              <li>CPU would be 2 Cores / 4 threads unless you increase the cluster size beyond 2.</li>
              <li>Disk space requirements are just enough room for the backup of your cache, and the number of backups
                you want to keep. The database files compress somewhat, so the disk size is less than the memory size.
              </li>
            </ul></li>
        </ul>
        <h4 id="download-and-install">Download and install required code and applications</h4>
        <p>So let's get started. The first thing you need to do is go to the <a
          href="https://github.com/vmware-samples/euc-samples">VMware Samples GitHub</a> and download the euc-samples
          repository. Once downloaded, unzip it, and open the euc-samples-master folder, then Windows-Samples,
          Tools &amp; Utilities, and finally Excel Add-In.</p>
        <p>Copy the simple_node_api folder and paste it to your c: drive. Next, copy the app folder and paste it into
          the simple_node_apifolder.</p>
        <p>The Next step is to install Nodejs. Go to https://nodejs.org/, download the latest LTS
          version, and run the installer. Accept all the defaults and, since I am not using modules which require
          compiling, you can skip the extra tools.</p>
        <p>Next, go to <a
          href="https://www.memurai.com/?utm_source=leo&utm_medium=video&utm_campaign=leo_video">Memurai</a> and
          download the latest developer
          version and run the installer.
          (Note: They gave me a tracking URL to use but there is no other arrangement
          between VMware and Memurai.) Accept all the defaults during the installation.</p>
        
        <h4 id="run-npm-install">Run NPM Install and verify connection</h4>
        <p>Now open the Node CMD prompt on the start menu. Cd to your simple-node-api folder. Run <span
          className="textMonospace bg-secondary text-white">npm install</span>. If all
          goes well, you should get no errors.</p>
        <p>if you get warnings about vulnerabilities, run <span className="textMonospace bg-secondary text-white">npm audit fix</span> and
          hopefully NPM can automatically upgrade
          the required dependencies to mitigate the vulnerabilities automatically. (Its almost like security magic :)
          )</p>
        
        <h4 id="run-npm-start">Run NPM Start</h4>
        <p>Finally, <span className="textMonospace bg-secondary text-white">run npm start</span> to start the API and be
          ready to connect.</p>
        <p>You should get prompted to install the root certificate which is automatically generated by the
          "office-addin-dev-certs" module I am using for that purpose. Its produced by microsoft and you can see the
          reference <a href='https://www.npmjs.com/package/office-addin-dev-certs'>here</a></p>
        
        <h3>If you are running Excel on the same computer, you can skip to the Excel configuration.</h3>
        
        <h3>If you are accessing from another computer, this next section is for you.</h3>
        <Image alt="Certificate Install" width='500' src='../images/WSONECertificateError.png' fluid/>
        <p>I am editing the module to add the hostname of your computer so that you can access it from other computers
          on your network by just trusting the certificate that is generated.</p>
        <Image alt="Certificate Example" width='500' src='../images/WSONECertificateExample.png' fluid/>
        <p>If you have your own CA, you can generate the required PEM certificates and put them in the same folder as
          the same filenames and you are good to go.</p>
        
        <h4 id="edit-firewall-rules">Edit your firewall rules to allow access</h4>
        <p>The next step is to edit your firewall rules to allow access to port 443 on the caching API.</p>
        <Image alt="Add Firewall Rules" width='800' src='../images/WSONEFirewallRules.png' fluid/>
        <p>Click on Start - Settings: </p>
        <ul>
          <li>Search for Firewall</li>
          <li>Click on Advanced Settings</li>
          <li>Click on Inbound Rules</li>
          <li>Click on Add Rule</li>
        </ul>
        <Image alt="Firewall Rule Details" width='800' src='../images/WSONEFirewallRule.png' fluid/>
        <p>Allow port 443 from all except Public</p>
        
        <h4 id="edit-hosts-file">Edit your hosts file and trust the certificate</h4>
        <p>If accessing from another computer, you need to edit the hosts file on the computer which has Excel on it to
          access the Caching API
          server and that computer has to trust the certificate.</p>
        <h5>First Edit the hosts. file</h5>
        <Image alt="Edit hosts." width='800' src='../images/WSONEEditHosts.png' fluid/>
        <ul>
          <li>Open and cmd prompt as Administrator on both the Caching API and the computer running Excel</li>
          <li>On the Excel computer, Type <span className="textMonospace bg-secondary text-white">notepad
            c:\windows\system32\drivers\etc\hosts.</span> (don't forget the
            period at the
            end)
          </li>
          <li>On the API backend, type <span className="textMonospace bg-secondary text-white">ipconfig</span></li>
          <li>Take the IP address and add it on a blank line of your hosts. file on the Excel computer</li>
          <li>On the API backend type <span className="textMonospace bg-secondary text-white">hostname</span></li>
          <li>Take the hostname and put it to right of the ip address (with a space in between) in your hosts. file on
            the Excel computer
          </li>
          <li>Save the file.</li>
        </ul>
        <h5>Then trust the ca certificate</h5>
        <p>First copy the ca.crt from the C:\Users\YourUserName\.office-addin-dev-certs to a temp folder on your Excel
          computer</p>
        <h5>Trust the certificate</h5>
        <Image alt="Trust ca certificate" width='800' src='../images/WSONEInstallCACertificate.png' fluid/>
        <ul>
          <li>Double click on the ca.crt</li>
          <li>Click Install Certificate</li>
          <li>Click Next</li>
          <li>Click Browse to select your cert store</li>
          <li>Choose Trusted Root Certificate Authorities</li>
          <li>Click OK</li>
          <li>Click Next</li>
          <li>Click Finish</li>
        </ul>
        
        <h4 id="copy-and-edit-manifest.xml">Copy the Manifest.xml file and change the hostname to match the API
          backend</h4>
        <p>Go back to your euc-samples-master folder, then Windows-Samples,
          Tools &amp; Utilities, and finally Excel Add-In.</p>
        <p>Copy the manifest.xml to the temp folder on your Excel computer</p>
        <h5>Edit the manifest.xml</h5>
        <Image alt="Edit Manifest" width='800' src='../images/WSONEEditManifest.png' fluid/>
        <ul>
          <li>Right click on the manifest.xml and click edit</li>
          <li>Click Open the Edit menu and click Replace</li>
          <li>In "Find What" put /localhost/</li>
          <li>In "Replace With" put /YourAPIBackendHostName/</li>
          <li>Click "Replace All"</li>
          <li>Save your manifest.xml</li>
        </ul>
        <br/>
        
        <h5 id="configure-excel">Configure Excel and run the Workspace ONE Excel Add-In</h5>
        
        <h5>Use the guides for your platform to setup Excel</h5>
        <Image alt="Configure Excel using the guides" width='800' src='../images/WSONEInstallGuidesLink.png' fluid/>
        <p>Reach out if you have trouble and we will be happy to help you setup the application.</p>
        <p>Next go to the Usage documentation and learn how to use the Workspace ONE Excel Add-In</p>
        <br/>
      </Container>
    </Container>
  );
};

